import { Global } from "@emotion/core";
import React from "react";
import { FOCUS_USING_BEFORE_CLASS_NAME, FOCUS_USING_ELEMENT_CLASS_NAME } from "../../../util/focusRing";
import { useFocusEventListener } from "../hooks/useFocusEventListener";
import { SHOW_FOCUS_MARKER, useFocusMode } from "../hooks/useFocusMode";

/**
 * The mouse event names to listen for to turn focus styles off.
 */
const mouseEvents = new Set(["mousedown"] as const);

/**
 * The keyboard event names to listen for to turn focus styles on.
 */
const keyEvents = new Set(["keydown"] as const);

/**
 * The key event codes to listen for to turn focus styles on.
 */
const keyCodes = new Set(["ArrowUp", "ArrowRight", "ArrowDown", "ArrowLeft", "Tab", "PageUp", "PageDown"] as const);

export const FocusToggleStyles = (): JSX.Element => {
    // Turn on/off the focus marker.
    const { focusMode, setFocusMode } = useFocusMode();

    useFocusEventListener({
        focusMode,
        mouseEvents,
        keyEvents,
        keyCodes,
        setFocusMode,
    });

    return (
        <Global
            styles={{
                // This style will hide all before elements with the FOCUS_ELEMENT_CLASS_NAME applied to them.
                // Most focus styles are applied as ::before elements in lodestar-core.
                [`body:not(.${SHOW_FOCUS_MARKER}) .${FOCUS_USING_BEFORE_CLASS_NAME}::before`]: {
                    display: "none",
                },

                // This style will hide the actual element (as opposed to the pseudoelement ::before) with the className
                // Most focus styles are applied as ::before elements in lodestar-core, but some need to be regular elements (like Tabs).
                [`body:not(.${SHOW_FOCUS_MARKER}) .${FOCUS_USING_ELEMENT_CLASS_NAME}`]: {
                    display: "none",
                },
            }}
        />
    );
};
